import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import DotChartOutlinedSvg from "@ant-design/icons-svg/es/asn/DotChartOutlined";
import AntdIcon from "../components/AntdIcon";
var DotChartOutlined = function DotChartOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DotChartOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(DotChartOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'DotChartOutlined';
}
export default RefIcon;